import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Transfer3 = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3 6.01a.8.8 0 0 1 1.13-.03l3.16 3a.8.8 0 0 1 0 1.161l-3.19 3.02a.8.8 0 0 1-1.1-1.162l1.72-1.629h-8.7a.8.8 0 0 1 0-1.6h8.726l-1.717-1.63a.8.8 0 0 1-.03-1.13Zm-8.54 5.27a.8.8 0 0 1-.03 1.13l-1.715 1.63h8.665a.8.8 0 0 1 0 1.6H5.994l1.717 1.63a.8.8 0 0 1-1.102 1.16l-3.16-3a.8.8 0 0 1 0-1.16l3.18-3.02a.8.8 0 0 1 1.131.03Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Transfer3
